import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import { resetPasswordRequest } from "../actions/userActions";
import { useNavigate } from "react-router-dom";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userReset = useSelector((state) => state.userPasswordReset);
  const { loading, error, success } = userReset;

  const submitHandler = (e) => {
    e.preventDefault();
    if (email) {
      setMessage(null);
      dispatch(resetPasswordRequest(email));
    } else {
      setMessage(
        "Necesitamos tu correo electrónico para enviarte las instrucciones."
      );
    }
  };

  useEffect(() => {
    if (success) {
      setMessage(
        "Hemos enviado un correo con instrucciones para cambiar tu contraseña. Revisa tu bandeja de entrada o spam."
      );
    }
  }, [navigate, success]);

  return (
    <div className="hadacy-auth">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');

        /* ─── HADACY · auth screens (login / register / forgot password) ───
           Single visual system shared across all three screens. The same
           .hadacy-auth namespace is redeclared in each screen so they all
           flip in sync via dark-mode.css. */
        .hadacy-auth {
          --cream: #f5f0e8;
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --muted: #7a6e62;
          --card-bg: #faf7f2;
          --recess: #efe7d8;
          --danger: #b04a3c;
          font-family: "Jost", sans-serif;
          max-width: 480px;
          margin: 2.5rem auto;
          padding: 0 1rem;
        }
        .hadacy-auth__card {
          background: var(--card-bg);
          border: 1px solid rgba(184, 147, 58, 0.18);
          border-radius: 16px;
          padding: 2.4rem 2.2rem;
          box-shadow: 0 14px 40px rgba(26, 20, 16, 0.06);
        }
        @media (max-width: 480px) {
          .hadacy-auth__card { padding: 1.8rem 1.4rem; }
        }
        .hadacy-auth__brand {
          text-align: center;
          font-size: 0.66rem;
          letter-spacing: 0.42em;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.6rem;
        }
        .hadacy-auth__heading {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          letter-spacing: 0.02em;
          color: var(--dark);
          font-size: 2.1rem;
          line-height: 1.15;
          text-align: center;
          margin: 0 0 0.4rem 0;
        }
        .hadacy-auth__heading::after {
          content: "";
          display: block;
          width: 36px; height: 1px;
          background: var(--gold);
          margin: 0.7rem auto 0;
        }
        .hadacy-auth__lede {
          text-align: center;
          font-size: 0.88rem;
          color: var(--muted);
          margin: 0 0 1.6rem 0;
          line-height: 1.55;
        }

        .hadacy-auth__group { margin-bottom: 0.95rem; }
        .hadacy-auth__label {
          display: block;
          font-size: 0.62rem;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--muted);
          font-weight: 400;
          margin-bottom: 0.35rem;
        }
        .hadacy-auth__input {
          width: 100%;
          background: #fff;
          border: 1px solid rgba(184, 147, 58, 0.22);
          border-radius: 10px;
          padding: 0.7rem 0.95rem;
          font-family: "Jost", sans-serif;
          font-size: 0.95rem;
          color: var(--dark);
          box-shadow: none;
          transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
        }
        .hadacy-auth__input:focus {
          outline: none;
          border-color: var(--gold);
          background: #fff;
          box-shadow: 0 0 0 3px rgba(184, 147, 58, 0.14);
        }
        .hadacy-auth__input::placeholder {
          color: var(--muted);
          font-style: italic;
          opacity: 0.85;
        }

        .hadacy-auth__cta {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.55rem;
          width: 100%;
          padding: 0.9rem 1.5rem;
          margin-top: 0.6rem;
          border-radius: 999px;
          background: var(--dark);
          border: 1px solid var(--dark);
          color: var(--gold-light);
          font-family: "Jost", sans-serif;
          font-size: 0.72rem;
          letter-spacing: 0.24em;
          text-transform: uppercase;
          cursor: pointer;
          transition: background .2s ease, color .2s ease, border-color .2s ease, transform .2s ease;
        }
        .hadacy-auth__cta:hover:not(:disabled),
        .hadacy-auth__cta:focus:not(:disabled) {
          background: var(--gold);
          border-color: var(--gold);
          color: var(--dark);
        }
        .hadacy-auth__cta:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .hadacy-auth__footer {
          text-align: center;
          font-size: 0.85rem;
          color: var(--muted);
          margin-top: 1.4rem;
          letter-spacing: 0.01em;
        }
        .hadacy-auth__footer a {
          color: var(--gold);
          font-weight: 500;
          text-decoration: none;
          letter-spacing: 0.02em;
        }
        .hadacy-auth__footer a:hover { color: var(--dark); text-decoration: underline; }

        .hadacy-auth__banner {
          padding: 0.65rem 0.85rem;
          border-radius: 10px;
          margin-bottom: 1rem;
          font-size: 0.85rem;
          line-height: 1.45;
          border: 1px solid;
          display: flex;
          align-items: flex-start;
          gap: 0.55rem;
        }
        .hadacy-auth__banner i { margin-top: 2px; }
        .hadacy-auth__banner--danger {
          background: rgba(176, 74, 60, 0.08);
          border-color: rgba(176, 74, 60, 0.32);
          color: var(--danger);
        }
        .hadacy-auth__banner--info {
          background: rgba(184, 147, 58, 0.10);
          border-color: rgba(184, 147, 58, 0.32);
          color: var(--gold);
        }
      `}</style>

      <div className="hadacy-auth__card">
        <div className="hadacy-auth__brand">HADACY</div>
        <h1 className="hadacy-auth__heading">Recuperar contraseña</h1>
        <p className="hadacy-auth__lede">
          Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
        </p>

        {message && (
          <div
            className={`hadacy-auth__banner ${
              success
                ? "hadacy-auth__banner--info"
                : "hadacy-auth__banner--danger"
            }`}
          >
            <i
              className={
                success ? "fas fa-envelope" : "fas fa-exclamation-circle"
              }
            ></i>
            <span>{message}</span>
          </div>
        )}
        {error && (
          <div className="hadacy-auth__banner hadacy-auth__banner--danger">
            <i className="fas fa-exclamation-circle"></i>
            <span>{error}</span>
          </div>
        )}
        {loading && <Loader />}

        <form onSubmit={submitHandler} noValidate>
          <div className="hadacy-auth__group">
            <label htmlFor="email" className="hadacy-auth__label">
              Correo electrónico
            </label>
            <input
              id="email"
              type="email"
              className="hadacy-auth__input"
              placeholder="tu@correo.com"
              value={email}
              autoComplete="email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" className="hadacy-auth__cta" disabled={loading}>
            Enviar instrucciones <i className="fas fa-arrow-right"></i>
          </button>
        </form>

        <p className="hadacy-auth__footer">
          ¿Recordaste tu contraseña?{" "}
          <Link to="/login">Iniciar sesión</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;
